import styled, { css } from 'styled-components/macro';

export const WaveContainer = styled.div`
  flex: 1;
  min-width: 100px;
  position: relative;
  z-index: 0;
`;

export const VolumeControl = styled.input.attrs({
  type: 'range',
  min: 0,
  max: 1,
  step: 0.01,
})`
  writing-mode: vertical-lr;
  direction: rtl;
  height: 100px;
  width: 16px;
  cursor: pointer;
  appearance: none;
  background: transparent;

  ${({ theme }) => css`
    &::-webkit-slider-runnable-track {
      width: 4px;
      height: 100%;
      background: linear-gradient(
        to top,
        ${theme.colors.primary[500]} calc(var(--value, 0) * 100%),
        ${theme.colors.gray[300]} calc(var(--value, 0) * 100%)
      );
      border-radius: 2px;
    }

    &::-webkit-slider-thumb {
      appearance: none;
      width: 10px;
      height: 10px;
      background: ${theme.colors.primary[500]};
      border-radius: 50%;
      margin-left: -3px;
    }

    &::-moz-range-track {
      width: 4px;
      height: 100%;
      background: ${theme.colors.gray[300]};
      border-radius: 2px;
    }

    &::-moz-range-progress {
      background: ${theme.colors.primary[500]};
      border-radius: 2px;
    }

    &::-moz-range-thumb {
      width: 10px;
      height: 10px;
      background: ${theme.colors.primary[500]};
      border-radius: 50%;
      border: none;
    }

    &:hover::-webkit-slider-runnable-track {
      background: linear-gradient(
        to top,
        ${theme.colors.primary[600]} calc(var(--value, 0) * 100%),
        ${theme.colors.gray[300]} calc(var(--value, 0) * 100%)
      );
    }

    &:hover::-webkit-slider-thumb {
      background: ${theme.colors.primary[600]};
    }

    &:hover::-moz-range-progress {
      background: ${theme.colors.primary[600]};
    }

    &:hover::-moz-range-thumb {
      background: ${theme.colors.primary[600]};
    }
  `}
`;
